import { LitEntity, html, nothing } from '../../utility/lit-entity';

class BinMedicatedBanner extends LitEntity {
  static get properties() {
    return {
      medicated: { type: Boolean, attribute: false },
      binName: { type: String, attribute: false },
      binContentsHref: { type: String, attribute: false },
    };
  }

  render() {
    return html`
      <lit-entity .href="${this.binContentsHref}" @update="${this._onUpdateBinContents}"></lit-entity>
      ${this.renderBanner()}
    `;
  }

  renderBanner() {
    if (!this.medicated) {
      return nothing;
    }
    const name = this.entity?.properties?.name;

    return html`
      <bn-banner icon="fad fa-prescription-bottle-alt" severity="critical">
        ${name} currently contains medicated feed
      </bn-banner>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.binContentsHref = this.entity.getSubEntityByRel('https://api.binsentry.com/rel/bin-contents')?.href;
  }

  _onUpdateBinContents({ detail }) {
    this.medicated = detail?.entity?.properties?.medicated;
  }
}

window.customElements.define('bin-medicated-banner', BinMedicatedBanner);
